import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    dialogContent: {
        width: 'auto',
        minWidth: '300px',
        maxHeight: '200px',
        display: 'flex',
        padding: '12px 24px',
        borderBottom: '2px solid #f0f0f0'
    },
    options: {
        width: '300px',
        marginRight: '12px'
    },
    btnsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '12px 0'
    },
    closeBtn: {
        width: '120px',
    },
    deleteBtn: {
        width: '120px',
        backgroundColor: Colors.DARK_BLUE,
        marginRight: '12px',
        color: 'white',
        '&:hover': {
            backgroundColor: Colors.DARK_BLUE,
        }
    }
}))

export default useStyles